import axios from "axios";

export const cart = {
  namespaced: true,
  state: {
    cartItems: [],
  },
  mutations: {
    ADD_TO_CART(state, product) {
      state.cartItems.push(product);
    },
    REMOVE_FROM_CART(state, productId) {
      state.cartItems = state.cartItems.filter(
        (item) => item.productId !== productId,
      );
    },
  },
  actions: {
    async deleteFromCart({ commit, rootState }, productId) {
      try {
        const apiUrl = import.meta.env.VITE_MENUUS_API_URL;
        const authToken = rootState.auth.token;

        if (!authToken) {
          throw new Error("Token de autenticação não encontrado");
        }

        const response = await axios.delete(
          `${apiUrl}/api/v1/shopping-cart/${productId}`,
          {
            headers: {
              AuthorizationIntegrator: ` ${authToken}`,
            },
          },
        );

        commit("REMOVE_FROM_CART", productId);
      } catch (error) {
        console.error("Erro ao remover produto do carrinho:", error);
      }
    },
  },
  getters: {
    cartItems: (state) => state.cartItems,
  },
};

export default cart;
